
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { sdgsData } from "@/data/sdgs";
import { useMedia } from "./context";
import { MediaItemData } from "./types/mediaTypes";

interface MediaItemProps {
  item: MediaItemData;
}

const MediaItem: React.FC<MediaItemProps> = ({ item }) => {
  const { language } = useLanguage();
  const { setSelectedMedia } = useMedia();

  return (
    <div 
      key={item.id}
      className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
      onClick={() => setSelectedMedia(item)}
    >
      <div className="relative h-48">
        <img 
          src={item.image} 
          alt={language === "en" ? item.title.en : item.title.ar}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.onerror = null;
            target.src = "https://via.placeholder.com/400x300?text=Image+Not+Found";
          }}
        />
        {item.type === "video" && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/30">
            <div className="w-14 h-14 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
              <div className="w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-16 border-l-white ml-1"></div>
            </div>
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-white/80 backdrop-blur-sm text-xs font-medium">
          {item.type === "infographic" && (language === "en" ? "Infographic" : "رسم بياني")}
          {item.type === "photo" && (language === "en" ? "Photo" : "صورة")}
          {item.type === "video" && (language === "en" ? "Video" : "فيديو")}
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-bold text-palsustain-charcoal">
          {language === "en" ? item.title.en : item.title.ar}
        </h3>
        <div className="mt-2 flex items-center">
          <div 
            className="w-6 h-6 mr-2 rounded-full flex items-center justify-center text-xs font-medium text-white"
            style={{ backgroundColor: sdgsData.find(sdg => sdg.id === item.sdgId)?.color || "#999" }}
          >
            {item.sdgId}
          </div>
          <span className="text-sm text-palsustain-charcoal/70">
            {sdgsData.find(sdg => sdg.id === item.sdgId)?.shortTitle[language]}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MediaItem;
